module.exports = __webpack_public_path__ + "img/report_cover_ge_plain.cf33ddd6.png";